import { get } from 'api/request';
import urls from 'configs/urls';

export const getCampaignsInsights = () =>
  get(null, false, urls.generalUrls.getCampaignsInsights, null);
